import Vue from 'vue';
import ProxyUrl from '@/constants/ProxyUrls';

/*
  This store mange the account data, except for the cart. 
  the cart has its own store and section
*/
export default {
  namespaced: true,
  state :{
    givenNames: '',
    lastNames: '',
    email: '',
    phone: '',
    addresses: null,
    defaultAddressId: ''
  },

  actions: {
    // Get all de account data, except the cart
    async getAccountData({
      commit
    }) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'get',
          url: ProxyUrl.getAccountData
        });
        if (data.httpStatus === 200) {
          commit('setAccountData', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (err) {
        throw new Error(err);
      }
    },

    // PERSONAL INFO
    async getPersonalInfo({commit}) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'get',
          url: ProxyUrl.personalInfo
        });
        if (data.httpStatus === 200) {
          commit('setPersonalInfo', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (err) {
        throw new Error(err);
      }
    },

    async updatePersonalInfo({commit}, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'put',
          url: ProxyUrl.personalInfo,
          data: payload
        });
        if (data.httpStatus === 200) {
          commit('setPersonalInfo', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (err) {
        throw new Error(err);
      }
    },

    // SECURITY
    async changePassword({dispatch}, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'put',
          url: ProxyUrl.changePassword,
          data: payload
        });
        if (data.httpStatus === 200) {
          return;
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    async changePhoneNum({commit}, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'put',
          url: ProxyUrl.changePhoneNum,
          data: payload
        });
        if (data.httpStatus === 200) {
          commit('setPhone', data.responseData);
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    // ADDRESSES
    async getAddresses({commit}) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'get',
          url: ProxyUrl.address,
        });
        if (data.httpStatus === 200) {
          commit('setAddresses', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (err) {
        throw new Error(err);
      }
    },

    async addNewAddress({commit}, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'post',
          url: ProxyUrl.address,
          data: payload
        });
        if (data.httpStatus === 200) {
          commit('setAddresses', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (err) {
        throw new Error(err);
      }
    },

    async setDefaultAddress({commit}, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'put',
          url: ProxyUrl.setDefaultAddress,
          data: payload
        });
        if (data.httpStatus === 200) {
          commit('setAddresses', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (err) {
        throw new Error(err);
      }
    },

    async updateAddress({commit}, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'put',
          url: ProxyUrl.address,
          data: payload
        });
        if (data.httpStatus === 200) {
          commit('setAddresses', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (err) {
        throw new Error(err);
      }
    },

    async deleteAddress({commit}, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'delete',
          url: ProxyUrl.address,
          data: payload
        });
        if (data.httpStatus === 200) {
          commit('setAddresses', data.responseData);
        } else throw new Error(data.httpStatus);
      } catch (error) {
        throw new Error(err);
      }
    }
  },

  mutations: {
    setAccountData(state, payload) {
      state.givenNames = payload.givenNames;
      state.lastNames = payload.lastNames;
      state.email = payload.email;
      state.phone = payload.phone;
      state.addresses = _.cloneDeep(payload.addresses);
      state.defaultAddressId = payload.defaultAddressId;
    },

    // PERSONAL INFO
    setPersonalInfo(state, payload) {
      state.givenNames = payload.givenNames;
      state.lastNames = payload.lastNames;
    },

    // SECURITY
    setPhone(state, payload) {
      state.phone = payload.phone;
    },

    // ADDRESSES
    setAddresses(state, payload) {
      state.addresses = payload.addresses;
      if (payload.defaultAddressId) {
        state.defaultAddressId = payload.defaultAddressId;
      }
    }
  },

  getters: {
    // PERSONAL INFO
    getPersonalInfo(state) {
      return { givenNames: state.givenNames, lastNames: state.lastNames };
    },

    // SECURITY
    getPhone(state) {
      return state.phone;
    },

    // ADDRESSES
    getAddresses(state) {
      return state.addresses;
    },

    getDefaultAddressId(state) {
      return state.defaultAddressId;
    }
  }
};